<template>
    <td :col_key="col_key" :class="[classes]">
        <div class="d-flex justify-content-center">
            <div class="custom-control custom-switch pl-5">
                <input type="checkbox" class="custom-control-input table_selector_input" :value="element_id" :id="`${table_id}_${element_id}_selector_input`">
                <label class="custom-control-label" :for="`${table_id}_${element_id}_selector_input`"></label>
            </div>
        </div>
    </td>
</template>

<script>
export default {
    props: {
        col_key: {
            type: String,
            required: true,
        },
        classes: {
            type: Array,
            required: false,
            default: function () {
                return [];
            },
        },
        element_id: {
            type: Number,
            required: true,
        },
        table_id: {
            type: String,
            required: true,
        }
    },
}
</script>
